/**
 * DevExtreme (esm/__internal/viz/core/themes/generic/light/bullet.js)
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
export default {
  bullet: {
    color: "#e8c267",
    targetColor: "#666666",
    targetWidth: 4,
    showTarget: true,
    showZeroLevel: true,
    tooltip: {
      enabled: true
    }
  }
};